// extracted by mini-css-extract-plugin
export default {"texto":"Titulo_texto__RNjeM"};